import LearningPromotion from './ResearchTraining'

export default LearningPromotion
